<template>
    <!--SIDEBAR LEFT-->
    <v-navigation-drawer
      fixed app v-model="drawer" :clipped="clipped" enable-resize-watcher height="100%" color="secondary"
      class="side-left"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img :src="imageUrlComputed" v-on:error="ImgError" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-subtitle>{{ $escapeHtml.decode(promoterDetails.promoterName) }}</v-list-item-subtitle>
            <v-list-item-subtitle style="font-size: 11px;">{{ promoterDetails.id }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <template v-for="(item,i) in filteredItems">
          <v-list-group
            v-if="item.component"
            :key="i"
            no-action
            :prepend-icon="item.icon"
            @click="changeComponent(item.nameComponent)"
            :class="`${ item.nameComponent == 'serie' ? 'activeHC' : '' } ${ (item.nameComponent == 'serie' && $route.name == 'seriesDashboard') ? 'active' : '' }`"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  class="font-side-custom"
                  v-if="item.isComponents_"
                >{{item.title}}</v-list-item-title>
                <v-list-item-title
                  class="font-side-custom"
                  v-if="!item.isComponents_"
                >{{item.title}}</v-list-item-title>
              </v-list-item-content>
            </template>
            <component
              v-if="item.isComponents_ || item.force"
              :is="item.component"
              @isComponent="changeComponent"
            ></component>
          </v-list-group>
          <v-list-group
            v-else
            :key="i"
            no-action
            :prepend-icon="item.icon"
            append-icon=""
            @click="changeComponent(item.nameComponent)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  class="font-side-custom"
                  v-if="item.isComponents_"
                >{{item.title}}</v-list-item-title>
                <v-list-item-title
                  class="font-side-custom"
                  v-if="!item.isComponents_"
                >{{item.title}}</v-list-item-title>
              </v-list-item-content>
            </template>
            <component
              v-if="item.isComponents_ || item.force"
              :is="item.component"
              @isComponent="changeComponent"
            ></component>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import EventRaces from "@/components/dashboard/eventRaces/EventRaces.vue";
import EventList from "@/components/dashboard/eventRaces/EventList.vue";
import RaceOptions from "@/components/dashboard/eventRaces/RaceOptions.vue";
import SerieOptions from "@/components/dashboard/series/SerieOptions.vue";

export default {
    components: { EventRaces, EventList, RaceOptions, SerieOptions },
    props: ['drawerLeft','bandRail'],
    data() {
        return {
            clipped: false,
            failed_image: true,
        };
    },
    computed: {
        items() {
            return [
                {
                    title: this.$t("dashboard.menu.dashboard"),
                    icon: "fa-home",
                    isComponents_: false,
                    force: false,
                    nameComponent: "promoter_dashboard",
                    component: null,
                },
                {
                    title: this.$t("dashboard.menu.profile"),
                    icon: "far fa-user",
                    isComponents_: false,
                    force: false,
                    nameComponent: "Profile",
                    component: null,
                },
                {
                    title: this.$t("dashboard.menu.eventRaces"),
                    icon: "fa-calendar-alt",
                    isComponents_: false,
                    force: true,
                    nameComponent: "EventList",
                    component: EventRaces,
                },
                {
                    title: this.$t("dashboard.menu.races"),
                    icon: "fa-calendar-alt",
                    isComponents_: false,
                    force: true,
                    nameComponent: "RaceList",
                    component: RaceOptions,
                },
                {
                    title: this.$t("dashboard.menu.series"),
                    icon: "far fa-calendar",
                    isComponents_: false,
                    force: true,
                    nameComponent: "serie",
                    component: SerieOptions,
                },
                {
                    title: "Result Editor",
                    icon: "fa-calendar-alt",
                    isComponents_: false,
                    force: true,
                    nameComponent: "EventList",
                    component: EventRaces,
                    page: "/raceEdit",
                },
                {
                    title: this.$t("dashboard.menu.reports"),
                    icon: "far fa-calendar",
                    isComponents_: false,
                    force: false,
                    nameComponent: "reports",
                    component: null,
                },
            ];
        },
        filteredItems() {
            var filteredItems = [];

            for (var i = 0; i < this.items.length; i++) {
                if (
                typeof this.items[i].page == "undefined" ||
                this.$route.fullPath.includes(this.items[i].page)
                ) {
                filteredItems.push(this.items[i]);
                }
            }
            return filteredItems;
        },
        drawer: {
          get() {
            return this.drawerLeft;
          },
          set(value) {
            this.$emit('changeDrawerLeft',value);
          }
        },
        ...mapState({
          user: (state) => { return state.session.session.userSession },
          imageUrl: (state) => state.session.session.imageUrl
        }),
        imageUrlComputed() {
          if(!this.failed_image) {
            return require("@/assets/images/orgPlaceholder.jpg.png");
          }
          return this.imageUrl;
        },
        promoterDetails() {
          return {
            id: this.user ? this.user.id : '',
            promoterName: this.user ? this.user.promoterName : ''
          };
        }
    },
    methods: {
        async ImgError() {
            this.failed_image = false;
        },
        changeComponent(component) {
            var path = "";

            if (component == "promoter_dashboard") path = `/dashBoard`;
            else if (component == "reports") path = `/reportsDashboard`;
            else if (component == "serie") path = `/seriesDashboard`;
            else if (component == "EventList") path = `/eventList`;
            else if (component == "CreateEvents") path = `/eventList/eventCreate`;
            else if (component == "RaceList") path = `/raceList`;
            else if (component == "Profile") path = `/profile`;

            if (this.$route.path !== path && path != "") {
                this.$router.push({
                path: path,
                });
            } else {
                if (component == "create_event") {
                this.ceKey += 1;
                }
            }

            this.isComponents = component;
        },
    }
};
</script>

<style lang="scss">
@media only screen and (min-width: 1264px) {
  .side-left { max-height: calc(100% - 150px) !important; 
    .v-navigation-drawer__content { border-bottom: 1px solid rgba(0, 0, 0, 0.12); }
  }
}
</style>